// extracted by mini-css-extract-plugin
export default {"otp-box-list-con":"ForgotPasswordOTPInput_otp-box-list-con__a78AJ","link":"ForgotPasswordOTPInput_link__6PbHa"};